/* eslint-disable camelcase */
/**
 * @package pages/realtors/realtors
 */
import 'sticky-kit';

import { sendCriteoEvent } from '@ma-js-common/criteo-helpers';
import $ from 'jquery';
import { v4 as uuidv4 } from 'uuid';

import { initInlineAccordion } from '../../common/accordion';
import { getSearchFormUrl } from '../../common/common.es6';
import * as Constant from '../../common/constants.es6';
import { computeCriteoAType, getRealtorIds } from '../../common/criteo-tagging';
import { isMobileOrTablet } from '../../common/device';
import Facebook from '../../common/facebook';
import { initializeFeaturedRealtors, loadFeaturedRealtors } from '../../common/featured-realtors';
import Form from '../../common/form';
import Ga from '../../common/ga';
import MAEvent from '../../common/ma-event';
import * as Popin from '../../common/popin.es6';
import * as RealtorMap from '../../common/realtor-map.es6';
import { initializePlacesTypeahead } from '../../common/search';
import { initializeDropdowns, updateFilterFields } from '../../common/search-filters.es6';
import HTTPService from '../../common/services/HTTPService.es6';
import { bindForm } from '../../common/tagging';
import spinnerTemplate from '../../common/templates/spinner-dots.html';
import { getThorViewEventProps, thorFormatPlaceName, thorPushEvent } from '../../common/thor';
import { addURLParams } from '../../common/utils';
import Wa from '../../common/wa';
import Paginate from '../../paginate';

/**
 * GA category of realtors directory
 * @type {String}
 */
const GA_CATEGORY = 'Annuaire agences';

/**
 * Realtors search container (notably containing containing search url)
 * @type {jQuery}
 */
const $realtorsSearchContainer = $('[data-realtors-search-url]');

/**
 * Search field for realtor name
 * @type {jQuery}
 */
const $realtorsSearchNameField = $('[data-realtors-search-name]');

/**
 * Selector for search results
 * @type {String}
 */
const realtorListSelector = '[data-realtor-list-content]';
/**
 * Selector for realtor Item in the list
 * @type {string}
 */
const realtorItemSelector = '[data-realtor-contact-item]';

/**
 * Container for search results
 * @type {jQuery}
 */
const $realtorList = $(realtorListSelector);

/**
 * Instance of paginator
 * @type {Paginate}
 */
let realtorListPaginate;

/**
 * Search field for place
 * @type {jQuery}
 */
const $realtorsSearchPlaceField = $('[data-realtor-relevant-past-sales-form-place]');

/**
 * Sort key.
 * @type {String}
 */
let sortKey = 'expertise:desc';

/**
 * Search bar
 */
let selectedPlace;

const resetSearchFieldError = searchFieldError => {
    searchFieldError.parents('.error').removeClass('error');
};

const handleSearchField = $searchField => event => {
    const $this = $(event.target);
    resetSearchFieldError($searchField);

    $searchField.off('keydown', handleSearchField($searchField));

    if (event.which === Constant.ENTER_KEYCODE) {
        const tabKeydown = $.Event('keydown');
        tabKeydown.keyCode = Constant.TAB_KEYCODE;
        tabKeydown.which = Constant.TAB_KEYCODE;

        $this.trigger(tabKeydown);
    }
};

const handleStartedTagging = $form => () => {
    $form.trigger(MAEvent.formStarted);
};

const getEventByPage = pathname => {
    if (pathname.includes('agence-immobiliere')) {
        return {
            pageTitle: 'agency_directory',
            businessType: 'agency',
        };
    }
    if (pathname.includes('mandataire-immobilier')) {
        return {
            pageTitle: 'representative_directory',
            businessType: 'representative',
        };
    }
    if (pathname.includes('professionnel-immobilier')) {
        return {
            pageTitle: 'pro_directory_search_results',
            businessType: 'all_professional_types',
        };
    }

    return {};
};

const searchTypes = {
    'ITEM_TYPE.APARTMENT': 'apartment',
    'ITEM_TYPE.HOUSE': 'house',
};

const getThorPlaceName = place => {
    const { geotype_label } = place;
    if (geotype_label === 'subregion') {
        return { av_province: place.zip };
    }
    if (geotype_label === 'address' || geotype_label === 'street') {
        return {
            av_city: thorFormatPlaceName(place.city.name),
            av_zip_code: place.zip,
            av_province: place.zip.slice(0, 2),
        };
    }
    return {
        av_city: thorFormatPlaceName(MA.Context.place.name_base),
        av_zip_code: place.zip,
        av_province: place.zip.slice(0, 2),
    };
};

const realtorMapThorPageview = () => {
    const { pageTitle, businessType } = getEventByPage(window.location.pathname);
    const { place, realtorCount, realtorSearchPlace } = window.MA.Context;
    const location = realtorSearchPlace.name_full || realtorSearchPlace.name;
    const params = new URLSearchParams(window.location.search);
    const luxuryAgency = params.get('luxury_agencies_only');
    const estate = params.get('area');
    const searchType = params.get('item_type');
    const pageNb = params.get('p') || 1;
    return {
        ...getThorViewEventProps('find_pro', `${pageTitle}_${place.geotype_label}`),
        ...getThorPlaceName(place),
        av_search: {
            business_type: luxuryAgency ? 'prestige_agency' : businessType,
            location,
            estate,
            search_type: searchTypes[searchType] || 'all_estate_types',
            sorting: sortKey,
            page_nb: pageNb,
            results_nb: realtorCount,
            country: 'france',
        },
    };
};

/**
 * Function used to initialize panels displaying realtors details
 */
function initializeRealtorsDetails() {
    RealtorMap.initializeShowRealtorDetails('realtor-contact');
    Popin.initializePastSalePopin('data-reference-message', false);
    Popin.initializeRealtorMessagePopin(
        GA_CATEGORY,
        'realtor:message_form',
        'from:realtors:realtors_list',
        'realtors',
    );

    $('[data-realtor-contact-item]').one('click', () => {
        Facebook.track('track', 'Lead');
        Facebook.track('trackCustom', 'Lead_Preview_Vitrine');
    });
}

/**
 * Initialize featured realtors
 */
function initializeComparatorFeaturedRealtors() {
    // Featured realtors are only displayed on comparator
    if ($realtorsSearchContainer.data('realtors-search-url').includes('professionnel-immobilier')) {
        initializeFeaturedRealtors(
            $('[data-realtors-featured-realtors]'),
            () => loadFeaturedRealtors(MA.Context.place, 'realtors'),
            {
                category: GA_CATEGORY,
                labelPrefix: 'realtors',
            },
        );
    }
}

/**
 * Get the search results from XHR
 * @param {String} sortKey
 */
function loadResults() {
    const realtorsSearchNameValue = $realtorsSearchNameField.val();

    if (realtorsSearchNameValue === '') {
        $realtorsSearchNameField.data('selected-place-id', '');
        $realtorsSearchNameField.data('selected-place-type', '');
    }
    $realtorList.html(spinnerTemplate({ classes: 'spinner--dots' }));

    HTTPService.getHTML($realtorsSearchContainer.data('realtors-search-url'), {
        sort: sortKey,
        name: realtorsSearchNameValue,
        place_id: $realtorsSearchPlaceField.data('selected-place-id'),
        place_type: $realtorsSearchPlaceField.data('selected-place-type'),
    }).then(response => {
        MA.Context.waData.pageview_id = uuidv4();
        $realtorList.html(response.data);
        realtorListPaginate.refetchPaginationControls();
        Wa.setDisplayTracking($realtorList, MA.Context.waData);
        initializeRealtorsDetails();
        initInlineAccordion(
            '.realtor-dropdown',
            '.realtor-dropdown__header',
            '.realtor-dropdown__content',
        );
        initializeComparatorFeaturedRealtors();
    });
}

/**
 * Send a GA event when sorting is done
 * @param {String} sortKey
 */
function sendSortTagging() {
    Ga.send({
        hitType: 'event',
        eventCategory: GA_CATEGORY,
        eventAction: `realtors:realtors_list:sort_by:${sortKey}`,
        eventLabel: 'realtors:realtors_list:sort_by_list',
    });
}

/**
 * Bind handlers on sorting tabs regarding place type (address or otherwise)
 * @param  {Object} place Place object
 */
function initSort(place) {
    const isAddressPlaceType = place.geotype_label === Constant.ADDRESS_GEOTYPE_LABEL;
    sortKey = isAddressPlaceType ? 'expertise:desc' : 'references:desc';

    $('#realtors-sort').on('change', event => {
        const $target = $(event.target);
        const featuredWrapper = document.querySelector('[data-realtors-featured-realtors]');
        if (featuredWrapper) {
            featuredWrapper.innerHTML = '';
        }
        if (sortKey === $target.val()) {
            return;
        }

        sortKey = $target.val();

        loadResults(sortKey);
        sendSortTagging(sortKey);
        thorPushEvent('page_view', realtorMapThorPageview());
    });
}

/**
 * Initialize pagination for list.
 */
function initPaginate() {
    realtorListPaginate = Paginate();
    realtorListPaginate.init(
        '[data-paginate-realtor]',
        realtorListSelector,
        () => ({
            sort: sortKey,
            name: $realtorsSearchNameField.val(),
            place_id: $realtorsSearchPlaceField.data('selected-place-id'),
            place_type: $realtorsSearchPlaceField.data('selected-place-type'),
        }),
        () => {
            initializeRealtorsDetails();
        },
    );
}

/**
 * Add tagging on change for given step field.
 * @param  {String} stepName Step name
 * @param  {jQuery} $field   jQuery Field
 */
function getStepStartedTagging(stepName) {
    return () => {
        Ga.send({
            hitType: 'event',
            eventCategory: GA_CATEGORY,
            eventAction: `find_a_pro:search_form:${stepName}:started`,
            eventLabel: 'realtors:realtors_list:search_bar',
        });
    };
}

/**
 * Keep the find best realtor form on top of the viewport when the user scroll down the page
 * * Only on Desktop
 */
function initializeStickyForm($form) {
    if (isMobileOrTablet()) {
        return;
    }

    $form.stick_in_parent({
        spacer: true,
        sticky_class: 'realtors-search-banner--sticky',
    });
}

/**
 * Initialize best realtor search form.
 */
function initializeBestRealtorsForm() {
    const $bestRealtorsSearchForm = $('[data-realtor-relevant-past-sales-form]:visible');
    if (!$bestRealtorsSearchForm.length) {
        return;
    }

    /**
     * Disabling submit on enter.
     */
    $bestRealtorsSearchForm.on('keypress', e => {
        if ((e.keyCode || e.which) === Constant.ENTER_KEYCODE) {
            e.preventDefault();
            return false;
        }

        return true;
    });

    initializeStickyForm($('[data-realtor-relevant-past-sales-form-banner]'));

    /**
     * Init search field
     */
    const $bestRealtorsSearchPlaceField = $bestRealtorsSearchForm.find(
        '[data-realtor-relevant-past-sales-form-place]',
    );
    const $bestRealtorSearchAreaField = $bestRealtorsSearchForm.find(
        '[data-realtor-relevant-past-sales-form-area]',
    );
    const $bestRealtorSearchLuxuryFilter = $bestRealtorsSearchForm.find(
        '#realtor-type-professionnel-immobilier-luxury',
    );
    const $bestRealtorsSearchPlaceFieldParent = $bestRealtorsSearchPlaceField.parents('.field');

    initializePlacesTypeahead($bestRealtorsSearchPlaceField);

    $bestRealtorsSearchPlaceField.on('keydown', handleSearchField($bestRealtorsSearchPlaceField));
    $bestRealtorsSearchPlaceField.keyup(handleStartedTagging($bestRealtorsSearchForm));

    const toggleSearchPlaceErrorClasses = () => {
        $bestRealtorsSearchPlaceFieldParent.toggleClass('field--invalid');
        $bestRealtorsSearchPlaceFieldParent.find('.field__errors').toggleClass('hide');
    };

    let eventPlace = null || MA.Context.place;
    $bestRealtorsSearchPlaceField.on('textchange', () => {
        eventPlace = null;

        if ($bestRealtorsSearchPlaceFieldParent.hasClass('field--invalid')) {
            toggleSearchPlaceErrorClasses();
        }
    });

    $bestRealtorsSearchPlaceField.on(MAEvent.placeSelected, event => {
        if (event.place) {
            eventPlace = event.place;
        }
    });

    // We need to trigger a down arrow keydown to show suggestions because
    // there is no simple way to do it with typeahead.js 0.10.5 (> 0.11 handles focus natively)
    const arrowKeydown = $.Event('keydown');
    arrowKeydown.keyCode = Constant.ARROW_DOWN_KEYCODE;
    arrowKeydown.which = Constant.ARROW_DOWN_KEYCODE;

    $bestRealtorsSearchPlaceField.on('focus', ({ target }) => {
        const $field = $(target);
        if ($field.val()) {
            $(target).trigger(arrowKeydown);
        }
    });

    $('[data-realtor-relevant-past-sales-form-button]').on('click', event => {
        event.preventDefault();

        $bestRealtorsSearchForm.trigger(MAEvent.formSubmitAttempt);

        if (eventPlace !== null) {
            getSearchFormUrl(eventPlace).then(url => {
                const actionUrl = $bestRealtorsSearchForm
                    .data('realtor-relevant-past-sales-form-url')
                    .replace(':slug', url);

                $bestRealtorsSearchForm.trigger(MAEvent.formSubmitSuccess);
                Ga.send({
                    hitType: 'event',
                    eventCategory: 'Annuaire agences',
                    eventAction: `go:find_a_pro:${eventPlace.geotype_label}`,
                    eventLabel: 'realtors:realtors_list:search_bar',
                });

                const $propertyType = $bestRealtorsSearchForm.find(
                    '[data-realtor-relevant-past-sales-form-property-type]:checked',
                );
                const params = {};

                if ($bestRealtorSearchAreaField.val()) {
                    params.area = $bestRealtorSearchAreaField.val();
                }
                if (
                    $propertyType.length === 1 &&
                    $propertyType.val() &&
                    $propertyType.val() !== 'all'
                ) {
                    params.item_type = $propertyType.val();
                }
                if ($bestRealtorSearchLuxuryFilter.is(':checked')) {
                    params.luxury_agencies_only = true;
                }

                let newUrl = '';

                const $realtorType = $bestRealtorsSearchForm.find(
                    '[data-realtor-relevant-past-sales-form-realtor-type]:checked',
                );
                if ($realtorType.length === 1 && $realtorType.val()) {
                    newUrl = actionUrl.replace(/[a-z]+-[a-z]+/, $realtorType.val());
                } else {
                    newUrl = actionUrl.replace(/[a-z]+-[a-z]+/, 'professionnel-immobilier');
                }
                document.location.href = addURLParams(newUrl, params);
            });
        } else {
            toggleSearchPlaceErrorClasses();

            Ga.send({
                hitType: 'event',
                eventCategory: 'Annuaire agences',
                eventAction: 'find_a_pro:search_form:submit_failed',
                eventLabel: 'realtors:realtors_list:search_bar',
            });
        }
    });

    /**
     * Initialize form tagging
     */
    Form.bindAjaxForm($bestRealtorsSearchForm, null, false);
    bindForm($bestRealtorsSearchForm, {
        category: GA_CATEGORY,
        actionPrefix: 'find_a_pro:search_form',
        label: 'realtors:realtors_list:search_bar',
    });

    /**
     * Started step tagging
     */
    $bestRealtorsSearchPlaceField.one('textchange', getStepStartedTagging('address'));
    $bestRealtorSearchAreaField.one('textchange', getStepStartedTagging('facts'));
    let propertyChanged = false;
    $bestRealtorsSearchForm.on('change', event => {
        if (!propertyChanged && event.target.name === 'property_type') {
            propertyChanged = true;
            getStepStartedTagging('type')();
        }
    });
}

/**
 * Initialize popin containing best realtor search form on mobile.
 */
function initializeBestRealtorsMobileForm() {
    Popin.initializeBestRealtorsFormPopin(initializeBestRealtorsForm);
}

/**
 * Initialize a typeahead field which lets user change the city in the search header
 */
function initializeSearchPlaceForm() {
    const $searchCityForm = $('[data-realtors-search-place-form]');

    if ($searchCityForm.length < 1) {
        return;
    }

    const $searchCityField = $searchCityForm.find('[data-realtors-search-place]');
    initializePlacesTypeahead($searchCityField);

    Form.bindAjaxForm($searchCityForm, null, false);

    bindForm($searchCityForm, {
        category: GA_CATEGORY,
        actionPrefix: 'find_a_pro:edit_city_box',
        label: 'realtors:realtors_list:edit_city_box',
    });

    $searchCityField.on('keydown', handleSearchField($searchCityField));
    $searchCityField.keyup(handleStartedTagging($searchCityForm));

    $searchCityField.on(MAEvent.placeSelected, ({ place }) => {
        $searchCityForm.trigger(MAEvent.formSubmitAttempt);

        if (place) {
            selectedPlace = place;
            getSearchFormUrl(selectedPlace).then(url => {
                const actionUrl = $searchCityField.data('url').replace(':slug', url);
                const eventActionPrefix = 'go:find_a_pro:';
                const label = eventActionPrefix + selectedPlace.geotype_label;

                Ga.send({
                    hitType: 'event',
                    eventCategory: GA_CATEGORY,
                    eventAction: label,
                    eventLabel: 'realtors:realtors_list:edit_city_box',
                });

                $searchCityForm.trigger(MAEvent.formSubmitSuccess);
                document.location.href = actionUrl;
            });
        }
    });
}

export function domReady(place) {
    thorPushEvent('page_view', realtorMapThorPageview());

    initSort(place);
    initPaginate();

    /**
     * Initialize hover on search result list item
     */
    if (!isMobileOrTablet()) {
        const mouseHandler = event => {
            event.preventDefault();
            $(event.target)
                .find('[data-realtor-actions]')
                .toggleClass('hide');
        };
        $realtorList.on('mouseout mouseover', '[data-realtor-search-result-item]', mouseHandler);
    }

    $(document).on('click', '[data-phone-number]', event => {
        const $this = $(event.target);
        if ($this.attr('href') === '#') {
            event.preventDefault();
            $this
                .attr('href', `tel:${$this.data('phone-number')}`)
                .find('[data-phone-placeholder]')
                .html($this.data('phone-call'));
        }
    });

    const form = document.querySelector('[data-realtor-relevant-past-sales-form]');

    initializeDropdowns(form);
    updateFilterFields();

    initializeBestRealtorsForm();
    initializeBestRealtorsMobileForm();
    initializeSearchPlaceForm();

    Wa.setTracking($('body'), MA.Context.waData);

    sendCriteoEvent({
        event: 'viewList',
        item: getRealtorIds(realtorItemSelector),
        atype: computeCriteoAType(realtorItemSelector),
    });

    initializeRealtorsDetails();
    initInlineAccordion(
        '.realtor-dropdown',
        '.realtor-dropdown__header',
        '.realtor-dropdown__content',
    );

    initializeComparatorFeaturedRealtors();
    const proLink = document.querySelector('[data-pro-link]');
    if (proLink) {
        proLink.addEventListener('click', () => {
            thorPushEvent('outlink', {
                link_url: 'https://pro.meilleursagents.com/',
                outbound: true,
                av_zone: 'bottom',
            });
        });
    }
}
